export const chatPanelTexts = {
    placeholder: "Type your message...",
    typingIndicator: "...",
    endChatAlert:
        "Thank you for your time! If you are ready to generate your summary, please press the 'End Chat' button ",
};

export const introPanelTexts = {
    welcomeTitle: "Welcome to our Study!",
    exploringTitle:
        "Exploring the use of pre-consultation chatbots",
    description:
    	"Pre-consultation is a way to provide information to your physician before your visit. " +
	"The interaction involves conversing with a pre-consutlation chatbot, detailing the reasons for the visit today. "+
	"You will get to review this information before it gets sent off to your doctor before your appointment.",
//        "so you will not be asked to give any personal" +
//        " health information. Participants will be asked to" +
//        " read the scenario, and engage with the chatbot as" +
//       " if you were the patient in the scenario. " +
//        " Upon finishing the interaction, participants" +
//        " would give feedback on the interaction experience. ",
    participationNotice:
        "The process should take around 10 minutes to complete.",
    invitation:
        " Your doctor will review this before your appointment.",
    continueButton: "Continue",
    beforeProceedTitle: "Before you proceed...",
    nextStageDescription:
       "You can click 'start' if you feel ready.",
    confirmationNotice: "Do you have any questions about the study?",
    startChatButton: "Start Chat",
};

export const learnMoreText = {
    placeholderText:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, " +
        "sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim " +
        "ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex " +
        "ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate" +
        " velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat" +
        " cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};

export const patientSummaryData = {
    "narrative summary": [
        {"narrative sentence": "Lorem ipsum dolor sit amet, consectetur adipiscing elit."},
        {"narrative sentence": "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."},
    ],
    "key information": [
        {name: "Key Info 1", information: "Ut enim ad minim veniam, quis nostrud exercitation."},
        {name: "Key Info 2", information: "Duis aute irure dolor in reprehenderit in voluptate velit esse."},
    ]
};

export const PASSKEY = "pineapple";
